export default __webpack_public_path__ + "static/media/fox_opt.3fe3cb5f.gif";